module.exports = __webpack_public_path__ + "static/media/chart_ausgeglichen.39af312f.svg";